<template>
  <div>
    <div class="parent">
      <v-card>
        <v-card-title class="info-title">
          <div class="text-center">{{ history.TarhName }}</div>
        </v-card-title>
        <div>
          <div style="padding: 15px">

            <v-row align="center">
              <v-col class="d-flex">
                <b>شهر محل تبلیغ:</b>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="content">
                <span v-html="history.FullAddress"></span>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="d-flex">

                <b>آدرس محل تبلیغ</b>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="content">
                <span v-html="history.MahaleEzam"></span>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="d-flex">
                <b>تاریخ شروع تبلیغ:</b>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="content">
                <span v-html="history.D_StartEzam"></span>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="d-flex">
                <b>تاریخ پایان تبلیغ: </b>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="content">
                <span v-html="history.D_EndEzam"></span>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="d-flex">
                <b>ملاحظات طلبه:</b>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="content">
                <span v-html="history.Des_Fard"></span>
              </v-col>
            </v-row>


            <v-row align="center">
              <v-col class="d-flex">
                <b>نظر ستاد تبلیغ: </b>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="content">
                <span v-html="history.Des_Setad"></span>
              </v-col>
            </v-row>

            <div style="padding: 5px"></div>
          </div>
        </div>
        <v-row v-if="history.IsRemovable" class="ltr">
          <v-btn color="red white--text" class="register" rounded @click="$emit('removeRequest', history)">
            حذف درخواست
          </v-btn>
        </v-row>
      </v-card>
    </div>
  </div>
</template>

<script>
import DetailRow from "@/components/DetailRow";
import { convertHTMLBody } from "@/utils/constants";

export default {
  props: ["history"],
  components: {
    appRow: DetailRow,
  },
  methods: {
    convertDesc() {
      return convertHTMLBody(this.history.Description);
    },
  },
};
</script>
